import type {
	Entity,
	ChangeMetadata,
} from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/update-jira/types';
import type { Issue as DomainIssue } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/domain/issues/types';
import type {
	Issue as ApiIssue,
	IssueValues,
} from '@atlassian/jira-portfolio-3-portfolio/src/common/api/types';
import type { IssueId } from '@atlassian/jira-portfolio-3-portfolio/src/common/types';
import type { Warning } from '@atlassian/jira-portfolio-3-portfolio/src/common/warning-details/types';

export {
	BUILT_IN_DATE_FIELDS,
	DUE_DATE,
	ISSUE_FIELDS,
	ISSUE_FIELD_TO_TYPE_MAP,
	TARGET_START_FIELD,
	TARGET_END_FIELD,
	TARGET_DATE_FIELD_TO_API_DATE_FIELD_MAP,
	// eslint-disable-next-line jira/export/no-external-exports
} from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/domain/issues/types';

export type IssueMap = Record<IssueId, DomainIssue>;
export type DescendantsMap = {
	[key: string]: string[];
};

export type IssueIdToChildIdsMap = {
	[key: string]: string[];
};
export type IssueIdToDescendantsIdsMap = {
	[key: string]: string[];
};

export type HierarchyValue = {
	start: number;
	end: number;
};

export type IssueRollUp = {
	estimate: number | null;
	release: string[] | null;
	team: Array<string | null | undefined> | null;
	sprint: string[] | null;
};

export type RollUps = Record<string, IssueRollUp>;

export type IssueChange = {
	id: string;
	category: Entity;
	metaData: ChangeMetadata;
	changeCount: number;
	warnings: Warning[];
	attributeName?: string | null;
	details: ApiIssue;
};

export type IssuesByVersionMap = {
	[key: string]: DomainIssue[];
};
export type IssuesStatusBreakdown = {
	byCategoryId: Record<string | number, number>;
	total: number;
	issueCount?: number;
};

export type IssuesBreakdownByEstimate = IssuesStatusBreakdown & {
	unestimated: number;
};

export type SimplifiedIssueValues = IssueValues & 'customField';
